
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-size: 16px;
  font-family: $fontTTNormsPro;
  font-weight: 400;
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  background-color: var(--background-color);
}

main {
  overflow: hidden;
  outline: 0;
}

p {
  margin: 0;
}

a {
  color: $blue;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

button {
  border: none;
  margin: 0;
  padding: 0;
  text-align: inherit;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
}

input {
  font: inherit;
  margin: 0;
  padding: 0;
}

@media (min-width: 768px) {
  main {
    padding-top: 0;
  }
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

/* Prevent outline on programmatically focusable elements */
[tabindex='-1']:focus {
  outline: 0;
}

section {
  scroll-margin-top: 60px;
}

.background {
  &.theme-default {
    background-color: $white;
    color: $slate;
  }

  &.theme-black {
    background-color: $slate;
    color: $white;
  }
  &.theme-blue {
    background-color: $blue;
    color: $white;
  }
  &.theme-gray {
    background-color: $gray;
    color: $white;
  }

  &.theme-light-blue {
    background-color: $sky;
    color: $slate;
  }
  &.theme-light-gray {
    background-color: $stone;
    color: $slate;
  }

  &.theme-light-orange {
    background-color: $coral-light;
    color: $slate;
  }

  &.theme-light-purple {
    background-color: $violet-light;
    color: $slate;
  }

  &.theme-light-teal {
    background-color: $ice;
    color: $slate;
  }

  &.theme-light-yellow {
    background-color: $tangerine-light;
    color: $slate;
  }

  &.theme-orange {
    background-color: $coral;
    color: $white;
  }

  &.theme-purple {
    background-color: $violet;
    color: $white;
  }

  &.theme-teal {
    background-color: $aqua;
    color: $white;
  }

  &.theme-ui-gray {
    background-color: $ui-gray;
    color: $white;
  }

  &.theme-ui-error {
    background-color: $ui-error;
    color: $white;
  }

  &.theme-ui-success {
    background-color: $ui-success;
    color: $white;
  }

  &.theme-ui-warning {
    background-color: $ui-warning;
    color: $white;
  }

  &.theme-white {
    background-color: $white;
    color: $slate;
  }

  &.theme-yellow {
    background-color: $tangerine;
    color: $white;
  }
}
`